import React from 'react';

const SvgBed = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 38 23" {...props}>
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={0.5}
      d="M35.071 22a.65.65 0 0 0 .643-.656v-1.969h.643a.65.65 0 0 0 .643-.656v-6.563c-.002-1.558-1.076-2.901-2.571-3.215V6.203c-.004-2.872-2.284-5.2-5.097-5.203H8.668c-2.813.004-5.093 2.33-5.097 5.203V8.94c-1.495.314-2.57 1.657-2.571 3.215v6.563a.65.65 0 0 0 .643.656h.643v1.969a.65.65 0 0 0 .643.656.65.65 0 0 0 .642-.656v-1.969H34.43v1.969a.65.65 0 0 0 .642.656zM4.857 6.203c.002-2.148 1.707-3.888 3.811-3.89h20.664c2.104.002 3.809 1.742 3.81 3.89v2.672h-2.616c-.222-1.504-1.486-2.619-2.976-2.625h-2.957c-1.491.005-2.756 1.12-2.978 2.625h-5.232c-.222-1.504-1.485-2.619-2.976-2.625H10.45c-1.491.005-2.756 1.12-2.978 2.625H4.857V6.203zm24.369 2.672h-6.31a1.747 1.747 0 0 1 1.679-1.313h2.955a1.75 1.75 0 0 1 1.676 1.313zm-14.143 0H8.774a1.747 1.747 0 0 1 1.678-1.313h2.955c.785.003 1.471.54 1.676 1.313zM2.286 12.156c0-1.087.863-1.969 1.928-1.969h29.572c1.065 0 1.928.882 1.928 1.97v5.905H2.286v-5.906z"
    />
  </svg>
);

export default SvgBed;
